import DynamicComponent from "../components/storyblok/dynamicComponent"
import Layout from "../components/layout/layout"
import Seo from "../components/seo"
import useStoryblok from "../lib/storyblok"

const Page = ({ pageContext, location }) => {
	let story = pageContext.story
	story = useStoryblok(story, location)

	// Extract SEO data from Storyblok content
	// Look for SEO block in the body content (usually first block)
	const seoBlock = story.content.body?.find(
		blok => blok.component === "seoBlock"
	)

	// Build SEO props from SEO block or use defaults
	// Supports both patterns: blok[key] (current) and blok.content[key] (if nested)
	const getSeoValue = (key, defaultValue = null) => {
		// Try direct access first (current pattern), then nested content (if exists)
		const value = seoBlock?.[key] ?? seoBlock?.content?.[key]
		
		// Handle empty strings as null
		if (value === "" || (Array.isArray(value) && value.length === 0)) {
			return defaultValue
		}
		// Handle arrays (like ogType: [""] or ogImage: [{...}])
		if (Array.isArray(value)) {
			const firstItem = value[0]
			if (firstItem === "" || firstItem === null || firstItem === undefined) {
				return defaultValue
			}
			// For ogImage array, return the filename from the first item
			if (key === "ogImage" && firstItem?.filename) {
				return firstItem.filename
			}
			// For other arrays, return the first non-empty item
			return firstItem || defaultValue
		}
		return value || defaultValue
	}

	const seoProps = {
		title: getSeoValue("title", story.name),
		description: getSeoValue("description", ""),
		keywords: getSeoValue("keywords", null),
		canonical: getSeoValue("canonical", null),
		ogImage: getSeoValue("ogImage", null),
		ogType: getSeoValue("ogType", "website"),
		twitterCard: getSeoValue("twitterCard", "summary_large_image"),
		twitterSite: getSeoValue("twitterSite", null),
		robots: getSeoValue("robots", null),
		noindex: getSeoValue("noindex", false),
		nofollow: getSeoValue("nofollow", false),
		structuredData: getSeoValue("structuredData", null),
	}

	// Build structured data if not provided but basic info is available
	if (!seoProps.structuredData) {
		seoProps.structuredData = {
			"@context": "https://schema.org",
			"@type": "WebPage",
			name: seoProps.title,
			description: seoProps.description,
			url:
				typeof window !== "undefined"
					? window.location.href
					: `https://ipweansw.org/${story.full_slug || story.slug}`,
		}
	}

	const components = story.content.body?.map(blok => {
		// Skip SEO block as it doesn't render anything visible
		if (blok.component === "seoBlock") {
			return null
		}
		return (
			<DynamicComponent
				blok={blok}
				key={blok._uid}
				isRTDPage={story.content?.isRTDPage}
			/>
		)
	})

	return (
		<Layout isRTDPage={story.content?.isRTDPage}>
			<Seo {...seoProps} />
			{components || story.content}
		</Layout>
	)
}

export default Page
